import { useEffect, useRef } from 'react';
import './starBackground.scss';

const StarBackground = () => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');

        const resize = () => {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        };
        resize();

        const stars = Array.from({ length: 350 }, () => ({
            x: Math.random() * canvas.width,
            y: Math.random() * canvas.height,
            r: Math.random() * 1.6 + 0.2,
            alpha: Math.random(),
            speed: Math.random() * 0.004 + 0.001,
        }));

        const shootingStars = [];
        const spawnShootingStar = () => {
            shootingStars.push({
                x: Math.random() * canvas.width * 0.7,
                y: Math.random() * canvas.height * 0.4,
                len: Math.random() * 120 + 60,
                speed: Math.random() * 6 + 4,
                alpha: 1,
                angle: Math.PI / 5,
            });
        };

        let lastShoot = 0;
        let animId;

        const draw = (time) => {
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            stars.forEach((s) => {
                s.alpha += s.speed;
                if (s.alpha > 1 || s.alpha < 0.1) s.speed *= -1;

                const grad = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.r * 2);
                grad.addColorStop(0, `rgba(200, 225, 255, ${s.alpha})`);
                grad.addColorStop(1, 'transparent');

                ctx.beginPath();
                ctx.arc(s.x, s.y, s.r, 0, Math.PI * 2);
                ctx.fillStyle = grad;
                ctx.fill();
            });

            if (time - lastShoot > 3500) {
                spawnShootingStar();
                lastShoot = time;
            }

            for (let i = shootingStars.length - 1; i >= 0; i--) {
                const ss = shootingStars[i];
                ss.x += Math.cos(ss.angle) * ss.speed;
                ss.y += Math.sin(ss.angle) * ss.speed;
                ss.alpha -= 0.018;

                if (ss.alpha <= 0) {
                    shootingStars.splice(i, 1);
                    continue;
                }

                const grad = ctx.createLinearGradient(
                    ss.x, ss.y,
                    ss.x - Math.cos(ss.angle) * ss.len,
                    ss.y - Math.sin(ss.angle) * ss.len,
                );
                grad.addColorStop(0, `rgba(180, 220, 255, ${ss.alpha})`);
                grad.addColorStop(1, 'transparent');

                ctx.beginPath();
                ctx.moveTo(ss.x, ss.y);
                ctx.lineTo(
                    ss.x - Math.cos(ss.angle) * ss.len,
                    ss.y - Math.sin(ss.angle) * ss.len,
                );
                ctx.strokeStyle = grad;
                ctx.lineWidth = 1.5;
                ctx.stroke();
            }

            animId = requestAnimationFrame(draw);
        };

        animId = requestAnimationFrame(draw);
        window.addEventListener('resize', resize);

        return () => {
            cancelAnimationFrame(animId);
            window.removeEventListener('resize', resize);
        };
    }, []);

    return <canvas ref={canvasRef} className="starCanvas" />;
};

export default StarBackground;
